module.exports = __webpack_public_path__ + "img/banner.0986ba08.png";